import React from 'react';
import { useSelector } from 'react-redux';
import { CChart } from '@coreui/react-chartjs';

const DBHome = () => {
  const products = useSelector((state) => state.products);

  const getFilteredProductCount = (category) => {
    return products?.filter((item) => item.product_category === category).length || 0;
  };

  const getStyle = (variableName) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variableName);
  };

  const extractUniqueCategories = () => {
    if (!products) return [];
    const uniqueCategories = Array.from(new Set(products.map((product) => product.product_category)));
    return uniqueCategories;
  };

  const categories = extractUniqueCategories();


  const chartData = categories.map((category) => getFilteredProductCount(category));



  return (
    <div className='flex items-center justify-center flex-col pt-6 w-full h-full'>
      <div className='grid w-full grid-cols-1 md:grid-cols-2 gap-4 h-full'>
        <div className='md:flex items-center justify-between'>
          <div className='w-340 md:w-508'>
            <CChart
              type='bar'
              data={{
                labels: categories,
                datasets: [
                  {
                    label: 'Số lượng trên danh mục ',
                    backgroundColor: '#f87979',
                    data: chartData,
                  },
                ],
              }}
              labels='months'
              options={{
                plugins: {
                  legend: {
                    labels: {
                      color: getStyle('--cui-body-color'),
                    },
                  },
                },
                scales: {
                  x: {
                    grid: {
                      color: getStyle('--cui-border-color-translucent'),
                    },
                    ticks: {
                      color: getStyle('--cui-body-color'),
                    },
                  },
                  y: {
                    grid: {
                      color: getStyle('--cui-border-color-translucent'),
                    },
                    ticks: {
                      color: getStyle('--cui-body-color'),
                    },
                  },
                },
              }}
            />
          </div>
        </div>
        <div className='w-full h-full flex items-center justify-center'>
          <div className='w-275 md:w-460'>
            <CChart
              type='doughnut'
              data={{
                labels: categories,
                datasets: [
                  {
                    backgroundColor: ['#41B883', '#E46651', '#00D8FF', '#DD1B16'],
                    data: chartData,
                  },
                ],
              }}
              options={{
                plugins: {
                  legend: {
                    labels: {
                      color: getStyle('--cui-body-color'),
                    },
                  },
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DBHome;
